export default __webpack_public_path__ + "media/images/new_year/header_1280x840-6c73c1ef120cd72841b16b0054d3371d.jpg";